export default $axios => ({
  fetch() {
    return $axios.$get('/v2/store-google-reviews')
  },
  getServiceName: () => 'storeGoogleReviewsService',
})
